import { Component, OnInit } from '@angular/core';

import { ReservationService } from '../../reservation.service';
import { Reservation, User } from '../../reservation.model';
import { ReservationSummaryApiService } from '../services/reservation-summary-api.service';
import { ReservationSummaryStoreService } from '../services/reservation-summary-store.service';
import { MatDialog } from '@angular/material/dialog';
import { ReservationSummaryGuideDialogComponent } from './reservation-summary-guide-dialog/reservation-summary-guide-dialog.component';
import { InfoboxService } from '../../../common/infobox/infobox.service';

@Component({
	selector: 'app-reservation-summary-guide',
	templateUrl: './reservation-summary-guide.component.html',
	styleUrls: ['./reservation-summary-guide.component.scss'],
})
export class ReservationSummaryGuideComponent implements OnInit {
	reservation: Reservation = null;
	responsibleUser: User = null;
	loggedUser: User;
	users: User[] = [];

	constructor(
		private readonly _service: ReservationService,
		private readonly apiService: ReservationSummaryApiService,
		private readonly store: ReservationSummaryStoreService,
		public dialog: MatDialog,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit() {
		const { getLoggedUser, getUsers } = this.apiService.actions();
		getLoggedUser();
		getUsers();
		const { loggedUser, users, reservation } = this.store.getters();
		loggedUser().subscribe((user) => {
			this.loggedUser = user;
		});
		users().subscribe((value) => {
			this.users = value;
		});
		reservation().subscribe((value) => {
			this.reservation = value;
			this.responsibleUser = this.reservation?.responsibleUser;
		});
	}

	get responsibleUserName() {
		return this.responsibleUser
			? `${this.responsibleUser.firstName} ${this.responsibleUser.lastName}`
			: 'Brak danych';
	}

	assignMe(user) {
		const { updateResponsibleUser } = this.apiService.actions();
		updateResponsibleUser(user.id, this.reservation.id).then(() => {
			this.infobox.success('Pomyślnie zmieniono opiekuna');
			const { getReservation } = this.apiService.actions();
			getReservation(this.reservation.id);
		});
	}

	openDialog() {
		const dialogRef = this.dialog.open(ReservationSummaryGuideDialogComponent, {
			width: '500px',
			data: {
				users: this.users.filter((v) => v.firstName.length && v.lastName.length),
				resId: this.reservation.id,
			},
		});
		dialogRef.afterClosed()?.subscribe((value) => {
			if (value) {
				const { getReservation } = this.apiService.actions();
				getReservation(this.reservation.id);
			}
		});
	}
}
